/**
 * Gated debug logging, ported verbatim from yaqatw's src/service/log.ts.
 *
 * `log()` forwards to `console.log` only in development builds; in production it
 * is a no-op, so diagnostic chatter (and any data it carries — usernames, API
 * payloads, document state) never reaches end users' consoles. CRA's build
 * inlines `process.env.NODE_ENV`, so the dev branch is dead-code eliminated
 * from production bundles.
 *
 * Use `console.warn` / `console.error` directly for problems that should always
 * surface regardless of build.
 */

const isDev = process.env.NODE_ENV !== "production";

export function log(...args: unknown[]): void {
  if (isDev) console.log(...args);
}

export default log;
